// extracted by mini-css-extract-plugin
export default {"container":"PresetsMenu_container__SSv-O","autoSelected":"PresetsMenu_autoSelected__kehyQ","customIcon":"PresetsMenu_customIcon__84auB","colorPanel":"PresetsMenu_colorPanel__PMClt"};